export default __webpack_public_path__ + "static/media/footer-gallery-2.aab68cc5.jpg";